import * as Actions from "./actions";
import { OtpState, createOrderInitialState } from "./state";

export const otpReducer = (
  state: OtpState = createOrderInitialState,
  action: Actions.OtpActions
): OtpState => {
  switch (action.type) {
    case Actions.SAVE_ORDER_TYPE:
      return { ...state,order:{...state.order,...action.payload} };
    case Actions.CREATE_ORDER_TYPE:
      return { ...state, isLoading: true };
    case Actions.CREATE_ORDER_SUCCESS_TYPE:
      return { ...state, isLoading: false };
    case Actions.CREATE_ORDER_FAILURE_TYPE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
